import { render, staticRenderFns } from "./TestMessage.vue?vue&type=template&id=45df9fdc&"
import script from "./TestMessage.vue?vue&type=script&lang=js&"
export * from "./TestMessage.vue?vue&type=script&lang=js&"
import style0 from "./TestMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports